import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { minicrudsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import { useSaveMinicrud } from './_requests/saveMinicrud'
import { useSessionPermission } from '@btime/react-session'

import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Minicruds($search: String, $page: Int, $filter: MinicrudFilter) {
    minicruds(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      entity
    }
  }
`

export const useMinicrudLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: minicrudsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'minicruds']))
  }
}

const MinicrudSelect = ({ onChange, value, entity, ...props }) => {
  const getOptions = useMinicrudLoader({ entities: entity })
  const canSetupServiceOrder = useSessionPermission('setupServiceOrder')

  const [onCreate] = useSaveMinicrud(entity, onChange)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={canSetupServiceOrder && onCreate}
      {...props}
    />
  )
}

export default MinicrudSelect
